module.exports = __webpack_public_path__ + "img/puce-logo.a27ace60.svg";